import angular from 'angular';
import procedureListComponent from './procedure-list.component';
import procedureListConfig from './procedure-list.config';
import ProcedureListService from "./procedure-list.service";


let procedureListModule = angular.module('procedureList', [])

    .component('procedureList', procedureListComponent)
    .service('ProcedureListService', ProcedureListService)
    .config(procedureListConfig);

export default procedureListModule;



// WEBPACK FOOTER //
// ./www/components/catalog/procedure-list/procedure-list.js